import PRODUCT_CONFIGS from '@/productConfigs';

export default function formatProduct(value) {
  return PRODUCT_CONFIGS.find((product) => value === product.type)?.productName;
}
